var exports = {
  "Y": "xcc377c0b--e8b6ec--modal-content",
  "H": "xcc377c0b--e8b6ec--aside",
};

module.exports = exports;
